import { useState, useEffect } from 'react';
import { gsap } from '../../animations/registerGsap';
import { EASE } from '../../animations/easing';
import Logo from '../Logo';
import { useReducedMotion } from '../../hooks/useReducedMotion';

const LoadingScreen = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    if (reducedMotion) {
      onComplete?.();
      return undefined;
    }

    let value = 0;
    const interval = setInterval(() => {
      value = Math.min(100, value + 22 + Math.random() * 10);
      setProgress(value);
      if (value >= 100) clearInterval(interval);
    }, 50);

    const maxWait = setTimeout(() => {
      setProgress(100);
      clearInterval(interval);
    }, 900);

    /* Never block the site if GSAP or animations fail */
    const forceDone = setTimeout(() => onComplete?.(), 2200);

    return () => {
      clearInterval(interval);
      clearTimeout(maxWait);
      clearTimeout(forceDone);
    };
  }, [reducedMotion, onComplete]);

  useEffect(() => {
    if (progress < 100) return undefined;

    const tl = gsap.timeline({ onComplete: () => onComplete?.() });
    tl.to('.loader-content', { opacity: 0, duration: 0.35, ease: EASE.luxury })
      .to('.loader-screen', { opacity: 0, duration: 0.4, ease: EASE.luxury }, '-=0.2');

    return () => tl.kill();
  }, [progress, onComplete]);

  if (reducedMotion) return null;

  return (
    <div className="loader-screen fixed inset-0 z-[200] flex items-center justify-center bg-lumora-dark">
      <div className="loader-content flex flex-col items-center gap-8">
        <Logo size="hero" />
        <div className="w-48 h-px bg-lumora-cream/10 relative overflow-hidden">
          <div
            className="absolute inset-y-0 left-0 bg-gradient-to-r from-lumora-wood to-lumora-gold"
            style={{ width: `${progress}%`, transition: 'width 0.1s linear' }}
          />
        </div>
        <p className="font-serif text-sm tracking-[0.4em] text-lumora-muted">{Math.round(progress)}%</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
